import { forwardRef, useImperativeHandle, useRef } from "react";
import { Badge, Button } from "@mantine/core";
import { IconUserPlus } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import WizardOverlay from "../Common/WizardOverlay";
import ContactsQuickAddWizard from "./ContactsQuickAddWizard";
import classes from "../Leads/LeadsQuickAdd.module.css";

export interface ContactsQuickAddWizardButtonRef {
  triggerClick: () => void;
}

interface ContactsQuickAddWizardButtonProps {
  closeCombobox: () => void;
  onCreated?: (contactId: string) => void;
  fromLookup?: boolean;
}

const ContactsQuickAddWizardButton = forwardRef<
  ContactsQuickAddWizardButtonRef,
  ContactsQuickAddWizardButtonProps
>(({ closeCombobox, onCreated, fromLookup = false }, ref) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { t } = useTranslation("features");

  useImperativeHandle(ref, () => ({
    triggerClick: () => {
      buttonRef.current?.click();
      closeCombobox();
    },
  }));

  return (
    <WizardOverlay
      WizardContent={
        <ContactsQuickAddWizard
          closeModal={closeCombobox}
          onCreated={onCreated}
          fromLookup={fromLookup}
        />
      }
      WizardTarget={
        <Button
          ref={buttonRef}
          w={"100%"}
          justify="space-between"
          visibleFrom="md"
          className={classes.footerButton}
          variant="default"
          color={"gray"}
          size="xs"
          pl={16}
          leftSection={
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <IconUserPlus size={16} />
              {t("wizards.QuickAddContact.QuickButtonLabel")}
            </span>
          }
          rightSection={
            !fromLookup && (
              <Badge color="gray" variant="light" size="xs" ml={16}>
                {"ctrl + C"}
              </Badge>
            )
          }
        />
      }
      onClick={() => {
        closeCombobox();
      }}
    />
  );
});

ContactsQuickAddWizardButton.displayName = "ContactsQuickAddWizardButton";

export default ContactsQuickAddWizardButton;
